import { useEffect, useState } from 'react';

/** Delays reflecting `value` until it has stopped changing for `delayMs`. Used for the queue search box so every keystroke doesn't fire a request. */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
